import { Divider, Group, Text } from '@mantine/core';

export function AuthDivider({ label }: { label: string }) {
	return (
		<Group>
			<Divider style={{ flexGrow: 1 }} />
			<Text ta="center" c="dimmed" fz="sm">
				{label}
			</Text>
			<Divider style={{ flexGrow: 1 }} />
		</Group>
	);
}
